module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Abb"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("1.")]), _vm._v(" Jo Holland (1938), head of MI(R).")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("2.")]), _vm._v(" Colin Gubbins, MI(R) and head of SOE.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("3.")]), _vm._v(" Millis Jefferis, head of MI(R)c.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("4.")]), _vm._v(" Laurence Grand, head of Section D, SIS.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("5.")]), _vm._v(" Daniel Sandford in Ethiopia, January 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("6.")]), _vm._v(" Peter Fleming, MI(R) and XII Corps Observation Unit.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("7.")]), _vm._v(" Alan Warren’s MI(R) identity card.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("8.")]), _vm._v(" Limpet mine, showing how it was carried by a diver to the target.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("9.")]), _vm._v(" Grenade No. 74 ST – the Sticky Bomb.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("10.")]), _vm._v(" 29mm spigot mortar (‘Blacker Bombard’).")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("11.")]), _vm._v(" Switch No. 1 Pull.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("12.")]), _vm._v(" Switch No. 2 Pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("13.")]), _vm._v(" Switch No. 3 Release.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("14.")]), _vm._v(" Switch No. 8 AP.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("15.")]), _vm._v(" Switch No. 9 L Delay.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("16.")]), _vm._v(" Autogyro, 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("17.")]), _vm._v(" Extract from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Use High Explosives")]), _vm._v(", 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("18.")]), _vm._v(" Webley Mk. VI revolver and Colt 1903 automatic pistol, as supplied to the Polish resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("19.")]), _vm._v(" Aerial photograph of Lochailort.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("20.")]), _vm._v(" Inverailort Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("21.")]), _vm._v(" Silk escape map of Romania, produced by MI9.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("22.")]), _vm._v(" Early miniature compass produced by MI9.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("23.")]), _vm._v(" Ploisti oilfield under aerial attack, 1943.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("24.")]), _vm._v(" Dymock Watson, head of MI(R) in Romania.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("25.")]), _vm._v(" No. 4 Independent Company shoulder flash (reproduction).")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("26.")]), _vm._v(" Armed ‘Puffer’ of the type used by the ‘Gubbins Flotilla’ in Norway.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("27.")]), _vm._v(" Bridge destroyed by the British at Mo i Rana, Norway.")])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("28.")]), _vm._v(" Bridge at Potthus, Norway, under repair by the German Army.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("29.")]), _vm._v(" Ethiopian Patriots being trained at El Wak on the Somalia/Kenya border in early 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("30.")]), _vm._v(" Martini-Enfield single shot .303 calibre rifle of the type supplied to the Ethiopian Patriots.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("31.")]), _vm._v(" Badges of Middle East Command and Sudan Defence Force.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("32.")]), _vm._v(" Maria Theresa Thaler, as provided by Mission 101 to the Ethiopian Patriots.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("33.")]), _vm._v(" Reconnaissance photograph of Leopoldville taken by Mission 19 in the Belgian Congo.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("34.")]), _vm._v(" Badges of General Service Corps and Intelligence Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig2"
  }, [_c('span', {
    staticClass: "list_fighangH"
  }, [_vm._v("35.")]), _vm._v(" Major General Jo Holland (1947).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed73027c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/List_of_Plates.vue
// module id = 69
// module chunks = 0